/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export { StorageAdapter } from "./StorageAdapter";
export {
  STORAGE_KEY_ACCESS_TOKEN_WITH_EXPIRY,
  STORAGE_KEY_IDP_JWT_TOKEN,
  STORAGE_KEY_BODY_ID,
  STORAGE_KEY_QUICK_MENU_SHORTCUT,
  STORAGE_KEY_QUICK_MENU_SHORTCUT_LANGUAGE,
  STORAGE_KEY_LAST_APP_VERSION,
  STORAGE_KEY_LANGUAGE,
  STORAGE_KEY_USER_PREFERRED_AUDIO,
  STORAGE_KEY_USER_PREFERRED_CC,
  STORAGE_KEY_USER_PREFERRED_AUDIO_DESCRIPTION,
  STORAGE_KEY_IS_TEXT_TRACK_ENABLED,
  STORAGE_KEY_SOFT_CLIENT_CERT,
  STORAGE_KEY_SOFT_CLIENT_CERT_KEY,
  STORAGE_KEY_LAST_TUNED_CHANNEL,
  STORAGE_KEY_PARTNER_ID,
  STORAGE_KEY_PARTNER_CUSTOMER_ID,
  STORAGE_KEY_DEVICE_UUID,
  STORAGE_KEY_OVERRIDE_DEVICE_TYPE,
  STORAGE_KEY_OVERRIDE_IP_AUTOLOGIN,
  STORAGE_KEY_ENABLE_IP_AUTOLOGIN,
  STORAGE_KEY_ACTIVE_PROFILE_SELECTION,
  STORAGE_KEY_PROFILE_DOMAIN_TOKEN_PREFIX,
  STORAGE_KEY_IP_JWT_TOKEN,
  STORAGE_KEY_LAST_AUTH_CONTEXT,
  STORAGE_KEY_GUIDE_SELECTED_FILTER_IDS
} from "./storageConfig";
export type { TStorageRecord } from "./storageDatabase";
